import { render, staticRenderFns } from "./AbroadYear.vue?vue&type=template&id=7c6b5094"
import script from "./AbroadYear.vue?vue&type=script&lang=js"
export * from "./AbroadYear.vue?vue&type=script&lang=js"
import style0 from "./AbroadYear.vue?vue&type=style&index=0&id=7c6b5094&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports